var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgAddCircle = function SvgAddCircle(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 2.51953C8.08594 2.51953 2.51953 8.08594 2.51953 15C2.51953 21.9141 8.08594 27.4805 15 27.4805C21.9141 27.4805 27.4805 21.9141 27.4805 15C27.4805 8.08594 21.9141 2.51953 15 2.51953ZM19.9805 16.2305H16.2305V19.9805C16.2305 20.6836 15.7031 21.2695 15 21.2695C14.2969 21.2695 13.7695 20.6836 13.7695 19.9805V16.2305H10.0195C9.31641 16.2305 8.73047 15.7031 8.73047 15C8.73047 14.2969 9.31641 13.7695 10.0195 13.7695H13.7695V10.0195C13.7695 9.31641 14.2969 8.73047 15 8.73047C15.7031 8.73047 16.2305 9.31641 16.2305 10.0195V13.7695H19.9805C20.6836 13.7695 21.2695 14.2969 21.2695 15C21.2695 15.7031 20.6836 16.2305 19.9805 16.2305Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgAddCircle);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-circle.254f688c3beda71e482016e157850a44.svg";